import React, { useEffect } from 'react';

/* Wraps an existing recruiting panel in the standard modal chrome.

   The point is that no second editor exists: a rail row opens OffersPanel,
   VisitsPanel or FollowingPanel unchanged, so the panels remain the single edit
   implementation and cannot drift from what the rail shows. */

export default function PanelModal({ title, onClose, children }) {
  useEffect(() => {
    const handleEsc = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', handleEsc);
    return () => document.removeEventListener('keydown', handleEsc);
  }, [onClose]);

  return (
    <div
      className="modal-overlay"
      role="dialog"
      aria-modal="true"
      aria-label={title}
      onClick={onClose}
    >
      <div
        className="modal-panel"
        style={{ maxWidth: 760 }}
        onClick={(e) => e.stopPropagation()}
      >
        <button className="modal-close" onClick={onClose} aria-label="Close">&times;</button>
        {children}
      </div>
    </div>
  );
}
